module.exports = __webpack_public_path__ + "img/logomark-beige-01.520509d6.svg";